import React, { Component } from 'react';
import Dock from 'react-dock';
import FontAwesomeIcon from 'react-fontawesome';
import {withRouter} from 'react-router-dom';
import './Sidebar.css';

import SearchBar from '../SearchBar/SearchBar';
import SchoolButtons from '../SchoolButtons/SchoolButtons';
import CatButtons from '../CatButtons/CatButtons';

var barStyle = {
  backgroundColor: '#445753',
  maxWidth: '340px',
  minWidth: '260px',
  display: 'block',
}

class Sidebar extends Component {
  constructor() {
    super();
    this.state = {
      isVisible: true,
      placeholderDisplay: 'block',
    }
  }

  _handleClick = () => {
    this.props.history.push("/" + this.props.navLink);
  }

  // TODO: add prop from app that checks if width is small
  // then display closing x that calls app function to close dock
  render() {
    return (
        <div className="placeholderDock" style={{display: this.state.placeholderDisplay}}>
          <Dock
            position='left'
            dimMode='none'
            defaultSize={0.25}
            dockStyle={barStyle}
            isVisible={this.state.isVisible}>
            <div className="navBar">
              <div className="arrowContainer">
                <FontAwesomeIcon
                  size="lg"
                  onClick={this._handleClick}
                  name="arrow-left" />
              </div>
              <h3>{this.props.navTitle}</h3>
            </div>
            <div className="barContainer">
              <h1>{this.props.title}</h1>
              <SearchBar
                searchValue={this.props.searchValue}
                shouldFocus={this.props.shouldSearchFocus}
                searchFunction={this.props.searchFunction} />
              <SchoolButtons />
              <CatButtons sort={this.props.sortFunction} selectedButtons={this.props.selectedButtons} />
            </div>
          </Dock>
        </div>
    )
  }
}

export default withRouter(Sidebar);



// WEBPACK FOOTER //
// ./src/components/Sidebar/Sidebar.js